const MAXIMAL_ZOOM = 3;
const MODES = {
  EDIT: 'drag',
  BRIGHTNESS: 'brightness',
  STRAIGHTEN: 'straighten',
  CROP: 'crop-zoom',
  ROTATE: 'rotate',
  FILTERS: 'filters',
};

const DEFAULT_MODE = MODES.CROP;

const EDIT_HEADER_TITLES = {
  rotate: 'Rotate',
  brightness: 'Brightness',
  straighten: 'Tilt',
  'crop-zoom': 'Crop & Zoom',
  filters: 'Filters',
};

const INITIAL_MIN_ZOOM = 1;

const EDIT_KEYS = [
  'angle', // rotate
  'crop', // crop/zoom
  'fx', // effects
  'gamma', // brightness
  'straighten', // tilt
];

const IMAGE_LOAD_TIMEOUT = 15000; // 15 sec timeout
const IMAGE_LOAD_ERROR_MESSAGE = {
  TIMEOUT:
    'The photo took too long to load. Please check your connection and try again.',
  FAILED:
    'Could not load the photo. The image may be inaccessible, please reload the page and try again.',
};

export {
  MODES,
  MAXIMAL_ZOOM,
  EDIT_HEADER_TITLES,
  DEFAULT_MODE,
  INITIAL_MIN_ZOOM,
  EDIT_KEYS,
  IMAGE_LOAD_TIMEOUT,
  IMAGE_LOAD_ERROR_MESSAGE,
};
